import { render } from "./LowStockProducts.vue?vue&type=template&id=ee0cfc4a&scoped=true"
import script from "./LowStockProducts.vue?vue&type=script&lang=js"
export * from "./LowStockProducts.vue?vue&type=script&lang=js"

import "./LowStockProducts.vue?vue&type=style&index=0&id=ee0cfc4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0cfc4a"]])

export default __exports__